import React from "react"

export default function Footer() {
  return (
    <footer className="footer bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 h-100 text-center text-lg-left my-auto">
            <ul className="list-inline mb-2">
              <li className="list-inline-item">&sdot;</li>
              <li className="list-inline-item">
                <a href="/terms">Terms of Use</a>
              </li>
              <li className="list-inline-item">&sdot;</li>
              <li className="list-inline-item">
                <a href="/privacy">Privacy Policy</a>
              </li>
            </ul>
            <p className="text-muted small mb-4 mb-lg-0">
              &copy; Sprancer LLC 2020-2021. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
